import { OutcomeAssessmentTable } from "./OutcomeAssessmentTable";

import { useFetchAndSelectMyAssessments } from "components/materials/section/assessment/assessment-data";
import { t } from "i18n/i18n";
import { useAppSelector } from "store/index";
import {
  NestedSectionOutcomeType,
  selectCurrentCourseId,
  selectCurrentUserId,
  selectPagesWithAssessmentsForCourseOutcomeAndUser,
} from "store/selectors";
import { useListSelector } from "store/store-hooks";

/**
 * Displays a list of all pages that are attached to the course outcome
 */
export const StudentOutcomeUseIndex = ({
  courseOutcome,
}: {
  courseOutcome: NestedSectionOutcomeType;
}) => {
  const userId = useAppSelector(selectCurrentUserId);
  const courseId = useAppSelector(selectCurrentCourseId);
  const pageAssessmentsForCourseOutcome = useListSelector((s) =>
    selectPagesWithAssessmentsForCourseOutcomeAndUser(s, courseOutcome.id, userId, courseId),
  );

  useFetchAndSelectMyAssessments();

  return (
    <OutcomeAssessmentTable
      data={pageAssessmentsForCourseOutcome}
      title={t("assessment_dashboard.student_outcome_page_list.title")}
    />
  );
};
